import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddStudent from "../components/AddStudent";


const AddStudentPage = () => {
  return (
    <>
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Student  </h5><Breadcrumb title="Add Student" /></div>

        {/* AddUserLayer */}
        <AddStudent />

    </>
  );
};

export default AddStudentPage;
